import React from 'react';
import { ShoppingCart, ArrowRight, Package, Zap } from 'lucide-react';
import { useCart } from '../contexts/CartContext';

const BottomCartBar = () => {
  const { cartItems, getCartTotal, getCartItemCount, setIsCartOpen } = useCart();

  if (cartItems.length === 0) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'linear-gradient(135deg, #ff6b35 0%, #dc2626 100%)',
      padding: '8px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      zIndex: 100,
      boxShadow: '0 -4px 16px rgba(255, 107, 53, 0.2)',
      borderRadius: '12px 12px 0 0'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        color: 'white'
      }}>
            <div style={{
              position: 'relative',
              width: '36px',
              height: '36px',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
            }}>
              <ShoppingCart size={18} color="white" />
              {getCartItemCount() > 0 && (
                <div style={{
                  position: 'absolute',
                  top: '-6px',
                  right: '-6px',
                  backgroundColor: '#dc2626',
                  color: 'white',
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px',
                  fontSize: '10px',
                  fontWeight: '700',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '2px solid white',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.2)'
                }}>
                  {getCartItemCount()}
                </div>
              )}
            </div>
        <div style={{
          fontSize: '14px',
          fontWeight: '600',
          margin: 0,
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}>
          <div style={{
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '4px',
            padding: '2px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Package size={12} color="white" />
          </div>
          {getCartItemCount()} item{getCartItemCount() > 1 ? 's' : ''} added
        </div>
      </div>
      
      <button
        onClick={() => setIsCartOpen(true)}
        style={{
          backgroundColor: 'white',
          color: '#ff6b35',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '12px',
          fontSize: '14px',
          fontWeight: '600',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          transition: 'all 0.2s ease',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#f8fafc';
          e.currentTarget.style.transform = 'scale(1.02)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'white';
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)';
        }}
      >
              <div style={{
                backgroundColor: '#ff6b35',
                borderRadius: '4px',
                padding: '1px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <Zap size={14} color="white" />
              </div>
              View Cart
              <div style={{
                backgroundColor: '#ff6b35',
                borderRadius: '4px',
                padding: '1px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <ArrowRight size={14} color="white" />
              </div>
      </button>
    </div>
  );
};

export default BottomCartBar;
